import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDHyUFz6rzzo3C56YoaEwFGw8htWnM8D6c",
  authDomain: "dahira-123bb.firebaseapp.com",
  projectId: "dahira-123bb",
  storageBucket: "dahira-123bb.firebasestorage.app",
  messagingSenderId: "620413934440",
  appId: "1:620413934440:web:f256d1a6ce94ecfe0cd4dd"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);

// Firestore avec cache local persistant (mode hors-ligne).
// Les données déjà consultées restent disponibles sans réseau (mode avion),
// et les écritures sont mises en file d'attente puis synchronisées au retour
// de la connexion. On retombe sur getFirestore() si l'init a déjà eu lieu
// (ex. Fast Refresh) ou si le navigateur ne supporte pas IndexedDB.
let _db;
try {
  _db = getApps().length > 1 ? getFirestore(app) : initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (e) {
  console.warn('Firestore persistent cache indisponible, fallback mémoire:', e?.message);
  _db = getFirestore(app);
}

export const db = _db;
export default app;
